export default {
  state: {
      URL:'https://www.shzhiming.cn/',
    lang: "zh_CN", //语言类型   zh_CN / EN / JAP
    scroll:0,
  },
  mutations: {
    //改变语言
    changeLang(state, content) {
      state.lang = content;
    },
    //监听页面高度
    changeClientH(state, content) {
      state.scroll = content;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/state.js